import { http, authHeader } from '@/http-commons';

class VentaPagoEvidenceFileService {

    uploadEvidence(evidence, ventaPagoId) {
        const formData = new FormData();
        formData.append('evidence', evidence);
        return http.post(`/api/v1/ventaPagoEvidenceFile/uploadEvidence/${ventaPagoId}`, formData, { headers: authHeader() });
    }

    table( params, ventaPagoId ) {
        return http.get(`api/v1/ventaPagoEvidenceFile/table/${ventaPagoId}`, { params, headers : authHeader() });
    }

}

export default new VentaPagoEvidenceFileService()